import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const Bin: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Bin #',
  // Sized for a 6-character bin. Cells are px-1 at text-xs and clip rather
  // than wrap, and a column without a maxWidth never expands past minWidth
  // (see use-column-sizing.ts), so this is the whole budget.
  minWidth: 55,
  accessorFn: (product) => product.bin,
  // Blank bins sort last: `compare` sends nullish to the end, and a blank bin
  // is the same idea — many products have none.
  sortKeyFn: (product) => product.bin || null,
});
